const metaCode = {
    MA01: { text: "M-ACT-001", value: "M-ACT-001", color: "gray" }
  };
  
export default metaCode;